export const certificates = ["Halal", "ISO 9001"];
export const tempTagMerchants = ["lyksvad", "luxtag", "demo"];
